import { useEffect } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;
const TAWK_SRC = 'https://embed.tawk.to/6a1b567bcf3b0d1c303a5e1a/1jptcjlev';

// Optional second chat box (Tawk.to) — on/off from Admin → Live Chat; sits above our own chat button
export default function TawkChat() {
  useEffect(() => {
    if (window.location.pathname.startsWith('/admin') || document.getElementById('tawk-script')) return;
    fetch(`${API}/api/chat/config`).then((r) => (r.ok ? r.json() : {})).then((cfg) => {
      if (!cfg.tawk_enabled || document.getElementById('tawk-script')) return;
      window.Tawk_API = window.Tawk_API || {};
      window.Tawk_API.customStyle = { visibility: { desktop: { position: 'br', xOffset: 24, yOffset: 100 }, mobile: { position: 'br', xOffset: 14, yOffset: 92 } } };
      window.Tawk_LoadStart = new Date();
      const s = document.createElement('script');
      Object.assign(s, { id: 'tawk-script', async: true, src: TAWK_SRC, charset: 'UTF-8' });
      s.setAttribute('crossorigin', '*');
      document.body.appendChild(s);
    }).catch(() => {});
  }, []);
  return null;
}
